export class LandingIntegrationEntity {
  name: string

  description: string

  category: string

  logoUrl: string | null

  isInDevelopment: boolean

  displayOrder: number

  constructor(data: Partial<LandingIntegrationEntity> = {}) {
    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.category = data.category ?? ""

    this.logoUrl = data.logoUrl ?? null

    this.isInDevelopment = data.isInDevelopment ?? false

    this.displayOrder = data.displayOrder ?? 0
  }
}
